import { Resources } from 'constants/resources';

import { blue } from '@mui/material/colors';
import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { usePermissions } from 'hooks/usePermissions';
import { queryClient } from 'providers/queryClient';
import { Link } from 'react-router-dom';
import { Stack } from 'shared/mui/Stack/Stack';
import { Tooltip } from 'shared/mui/Tooltip';
import { Typography } from 'shared/mui/Typography';
import { FunctionField, FunctionFieldProps } from 'shared/react-admin/Fields';
import { GatewayRuleActiveSwitch } from 'shared/widgets/GatewayRuleActiveSwitch/GatewayRuleActiveSwitch';
import { GatewayRule } from 'types/embedded/gatewayRule';
import { Permission } from 'types/embedded/permission';

type Props = Omit<FunctionFieldProps, 'render'> & { queryKey: string };

export const MerchantShowRulesNameField: React.FC<Props> = ({ label, source, queryKey }) => {
  const { hasResourcePermissions } = usePermissions();
  const { createPathWithQuery } = useCreatePathWithQuery();

  const onSuccess = async () => {
    await queryClient.invalidateQueries({ queryKey: [queryKey] });
  };

  return (
    <FunctionField
      label={label}
      render={(record: GatewayRule) => {
        return (
          <Stack alignItems="center" direction="row">
            {hasResourcePermissions(Resources.GatewayRules, [
              Permission.Full,
              Permission.Update,
            ]) && <GatewayRuleActiveSwitch onSuccess={onSuccess} size="small" />}
            <Tooltip title={<Typography fontSize={12}>{record.name}</Typography>}>
              <Link
                style={{ color: blue[700] }}
                target="_blank"
                to={createPathWithQuery({
                  resource: Resources.GatewayRules,
                  id: record.id,
                  type: 'show',
                })}
              >
                {record?.name}
              </Link>
            </Tooltip>
          </Stack>
        );
      }}
      sortable={false}
      source={source}
    />
  );
};
